import { Controller } from "@hotwired/stimulus"

// Simple controller to toggle cursor to and from waiting. 
// Cancelling removes the sidebar question.
export default class extends Controller {
  static targets = ["massChangeQuestion"]

  connect() {
    this.auto()
  }

  auto() {
    document.body.style.cursor = "auto";
  }
  
  wait() {
    document.body.style.cursor = "wait";
  }

  cancel() {
    this.massChangeQuestionTarget.remove()
  }
}
